import { gql } from '@apollo/client';

export default gql`
  query getTravelPassProductOffers($departureDate: String!) {
    getTravelPassProductOffers(departureDate: $departureDate) {
      productName
      tariffCode
      tariffCodeActual
      price
      validityDate
    }
  }
`;
